/**
 * Resolve a jewelry image URL for display.
 *
 * Three possible values stored in DB:
 *  1. Full Azure Blob URL  → "https://gdsjewelrystorage.blob.core.windows.net/..."  → use as-is
 *  2. Legacy local path    → "/uploads/jewelry-images/filename.jpg"                 → rewrite to backend
 *  3. null / empty         → return null (show placeholder)
 *
 * REACT_APP_API_URL can be:
 *  - "/api"                          → local dev (proxy), backend is at window.location.origin:3000
 *  - "https://api.example.com/api"   → absolute production URL
 */

// Derive the backend base URL (no trailing /api)
const getBackendBase = () => {
  const apiUrl = process.env.REACT_APP_API_URL || '';

  // Absolute URL — strip /api suffix to get backend root
  if (apiUrl.startsWith('http://') || apiUrl.startsWith('https://')) {
    return apiUrl.replace(/\/api\/?$/, '');
  }

  // Relative "/api" — in local dev the backend runs on port 3000
  if (typeof window !== 'undefined') {
    const { protocol, hostname } = window.location;
    return `${protocol}//${hostname}:3000`;
  }

  return '';
};

export const resolveImageUrl = (url) => {
  if (!url) return null;

  // Already an absolute URL (Azure Blob, http, https) — use as-is
  if (url.startsWith('http://') || url.startsWith('https://')) return url;

  // Legacy local /uploads/... path — proxy via backend
  if (url.startsWith('/uploads/')) {
    return `${getBackendBase()}${url}`;
  }

  // Fallback
  return url;
};
